import type { Auth } from "firebase/auth";
import { ApiError } from "./api";
import { readingTime } from "./format";
import { SERVER_PROBLEM } from "./save";
import { signOut } from "./signOut";

export type RefreshFailure = "network" | "server" | "session";

/** Why a refresh of a shown list or view failed. */
export function refreshFailure(e: unknown): RefreshFailure {
  const code = e instanceof ApiError ? e.status : 0;
  return code === 401 || code === 403 ? "session" : code >= 500 ? "server" : "network";
}

/** The red alert of a refresh that failed: the cause, the time of the shown data and the next step (rule U-36). */
export function RefreshFailed({ failed, at, timeZone, auth, retry }: { failed: RefreshFailure; at: number | null; timeZone?: string; auth: Auth; retry: () => void }) {
  if (failed === "session") {
    return (
      <p role="alert" className="error" data-testid="session-ended">
        Your session ended.{" "}
        <button className="primary" onClick={() => void signOut(auth)}>
          Sign in again
        </button>
      </p>
    );
  }
  return (
    <p role="alert" className="error" data-testid="refresh-failed">
      {failed === "server" ? SERVER_PROBLEM : "Cannot reach the server."}{" "}
      {at === null ? "" : `The page shows data from ${readingTime(new Date(at).toISOString(), timeZone)}. `}
      <button onClick={retry}>Try again</button>
    </p>
  );
}
